var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxGrouped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 54.6199L3.70138 56.6784L35.2963 38.4351L32.0936 36.378L0.5 54.6199Z",
    fill: "#D6B163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70189 56.6782V62.9264L35.2968 44.6845V38.4349L3.70189 56.6782Z",
    fill: "#91693A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0642 50.2234V53.8337L5.85928 60.3095V56.7217L17.0642 50.2234Z",
    fill: "#B78841"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8649 41.131V44.7427L21.6364 51.2171V47.6068L32.8649 41.131Z",
    fill: "#B78841"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 54.6203V61.0841L3.70138 62.927V56.6788L0.5 54.6203Z",
    fill: "#7D5129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9596 42.8747L32.8646 44.7413V41.131L29.9596 42.8747Z",
    fill: "#613F1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.158 51.9671L17.0629 53.8337V50.2234L14.158 51.9671Z",
    fill: "#613F1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6003 62.7572L17.8017 64.8144L49.3953 46.5725L46.1939 44.514L14.6003 62.7572Z",
    fill: "#D6B163"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8022 64.8135V71.063L49.3958 52.8198V46.5716L17.8022 64.8135Z",
    fill: "#91693A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.163 58.3608V61.9711L19.9568 68.4455V64.859L31.163 58.3608Z",
    fill: "#B78841"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9652 49.2684V52.8787L35.7366 59.3544V55.7441L46.9652 49.2684Z",
    fill: "#B78841"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6003 62.757V69.2195L17.8017 71.0636V64.8141L14.6003 62.757Z",
    fill: "#7D5129"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0599 51.0107L46.9649 52.8787V49.2684L44.0599 51.0107Z",
    fill: "#613F1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2582 60.1031L31.1632 61.9711V58.3608L28.2582 60.1031Z",
    fill: "#613F1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7025 70.8915L31.9052 72.9499L63.4989 54.708L60.2975 52.6495L28.7025 70.8915Z",
    fill: "#D6B163"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9044 72.9497V79.1979L63.4981 60.956V54.7078L31.9044 72.9497Z",
    fill: "#91693A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2667 66.4957V70.1059L34.0618 76.5817V72.9952L45.2667 66.4957Z",
    fill: "#B78841"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0688 57.4039V61.0142L49.8389 67.4886V63.8783L61.0688 57.4039Z",
    fill: "#B78841"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7025 70.8918V77.3557L31.9052 79.1985V72.9503L28.7025 70.8918Z",
    fill: "#7D5129"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1621 59.1461L61.0671 61.0141V57.4025L58.1621 59.1461Z",
    fill: "#613F1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3605 68.2393L45.2654 70.1059V66.4957L42.3605 68.2393Z",
    fill: "#613F1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1066 69.319L31.9052 71.3774L0.5 53.0482L3.70138 50.9897L35.1066 69.319Z",
    fill: "#D6B163"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9052 71.3772V72.9502L0.5 54.6209V53.048L31.9052 71.3772Z",
    fill: "#996232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1051 69.3195V71.1068L31.9037 72.951V71.378L35.1051 69.3195Z",
    fill: "#AD7E45"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2056 65.2195L39.0029 67.278L7.59897 48.9488L10.8003 46.8903L42.2056 65.2195Z",
    fill: "#D6B163"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0029 67.2778V68.8508L7.59897 50.5216V48.9486L39.0029 67.2778Z",
    fill: "#996232"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2054 65.2188V67.006L39.0027 68.8502V67.2772L42.2054 65.2188Z",
    fill: "#AD7E45"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3039 61.1202L46.1012 63.1786L14.696 44.8494L17.8987 42.791L49.3039 61.1202Z",
    fill: "#D6B163"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1012 63.1784V64.7514L14.696 46.4222V44.8492L46.1012 63.1784Z",
    fill: "#996232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3024 61.1207V62.9094L46.0997 64.7522V63.1792L49.3024 61.1207Z",
    fill: "#AD7E45"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4016 57.0184L53.2001 59.0769L21.7949 40.7477L24.9976 38.6892L56.4016 57.0184Z",
    fill: "#D6B163"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2001 59.0769V60.6499L21.7949 42.3206V40.7477L53.2001 59.0769Z",
    fill: "#996232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4001 57.0192V58.8079L53.1987 60.6507V59.0777L56.4001 57.0192Z",
    fill: "#AD7E45"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5006 52.9187L60.2991 54.9772L28.8939 36.648L32.0953 34.5895L63.5006 52.9187Z",
    fill: "#D6B163"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2991 54.977V56.55L28.8939 38.2208V36.6478L60.2991 54.977Z",
    fill: "#996232"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4991 52.918V54.7066L60.2977 56.5494V54.9765L63.4991 52.918Z",
    fill: "#AD7E45"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.362 52.566L46.9251 44.1442V36.0968L32.362 44.5186V52.566Z",
    fill: "#C9974B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3629 44.5187L46.926 36.0969L32.7859 27.8643L18.2228 36.2861L32.3629 44.5187Z",
    fill: "#EBC26C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2228 36.2869L32.3629 44.5195V52.5669L18.2228 44.3779V36.2869Z",
    fill: "#AB7835"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8351 39.6333L19.8403 40.9642L20.4529 41.3135L20.4477 39.9826L20.7533 40.1572L20.1381 38.8475L19.5294 39.4587L19.8351 39.6333Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 61.6246L31.2716 53.2029V45.1541L16.7086 53.5759V61.6246Z",
    fill: "#C9974B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7095 53.576L31.2726 45.1542L17.1324 36.923L2.56938 45.3448L16.7095 53.576Z",
    fill: "#EBC26C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56938 45.3448L16.7095 53.5761V61.6248L2.56938 53.4345V45.3448Z",
    fill: "#AB7835"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79976 49.5069L24.3944 41.0216L23.2561 40.3826L8.66147 48.8679V51.4119L9.82215 52.1051L9.79976 49.5069Z",
    fill: "#F2E5DA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18128 48.6908L4.18655 50.0217L4.79919 50.3722L4.79393 49.04L5.09957 49.216L4.48431 47.905L3.87564 48.5162L4.18128 48.6908Z",
    fill: "#471D1D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4718 61.2772L62.0348 52.8554V44.808L47.4718 53.2298V61.2772Z",
    fill: "#C9974B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4713 53.2299L62.0343 44.8081L47.8942 36.5755L33.3298 44.9973L47.4713 53.2299Z",
    fill: "#EBC26C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3298 44.9973L47.4713 53.2299V61.2773L33.3298 53.087V44.9973Z",
    fill: "#AB7835"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9448 48.3448L34.9501 49.6756L35.5613 50.0249L35.5574 48.694L35.863 48.8687L35.2478 47.559L34.6378 48.1688L34.9448 48.3448Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8183 70.338L46.3813 61.9162V53.8688L31.8183 62.2906V70.338Z",
    fill: "#C9974B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8179 62.2907L46.3809 53.869L32.2407 45.6364L17.6764 54.0581L31.8179 62.2907Z",
    fill: "#EBC26C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6764 54.0589L31.8179 62.2915V70.3389L17.6764 62.15V54.0589Z",
    fill: "#AB7835"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8275 58.2258L39.4221 49.7418L38.2838 49.1028L23.6892 57.5868V60.1308L24.8511 60.8253L24.8275 58.2258Z",
    fill: "#F2E5DA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2911 57.4046L19.2963 58.7355L19.9076 59.0848L19.9037 57.7539L20.2093 57.9285L19.5941 56.6188L18.9841 57.23L19.2911 57.4046Z",
    fill: "#471D1D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3624 43.545L46.9255 35.1232V27.0758L32.3624 35.4976V43.545Z",
    fill: "#C9974B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3633 35.4977L46.9264 27.0759L32.7862 18.8433L18.2232 27.2651L32.3633 35.4977Z",
    fill: "#EBC26C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2232 27.2651L32.3633 35.4977V43.5451L18.2232 35.3549V27.2651Z",
    fill: "#AB7835"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8366 30.6118L19.8419 31.9426L20.4545 32.2919L20.4492 30.9611L20.7549 31.1357L20.1396 29.826L19.5309 30.4372L19.8366 30.6118Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 52.6025L31.2716 44.1807V36.1333L16.7086 44.5551V52.6025Z",
    fill: "#C9974B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7095 44.5552L31.2726 36.1334L17.1324 27.9008L2.56938 36.3226L16.7095 44.5552Z",
    fill: "#EBC26C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56938 36.3226L16.7095 44.5552V52.6026L2.56938 44.4137V36.3226Z",
    fill: "#AB7835"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79976 40.4745L24.3944 31.9892L23.2561 31.3516L8.66147 39.8355V42.3795L9.82215 43.0727L9.79976 40.4745Z",
    fill: "#F2E5DA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18128 39.67L4.18655 41.0009L4.79919 41.3501L4.79393 40.0193L5.09957 40.1939L4.48431 38.8842L3.87564 39.4954L4.18128 39.67Z",
    fill: "#471D1D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4718 52.2561L62.0348 43.8343V35.7869L47.4718 44.2074V52.2561Z",
    fill: "#C9974B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4713 44.2075L62.0343 35.787L47.8942 27.5544L33.3298 35.9762L47.4713 44.2075Z",
    fill: "#EBC26C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3298 35.9763L47.4713 44.2075V52.2563L33.3298 44.066V35.9763Z",
    fill: "#AB7835"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9448 39.3222L34.9501 40.6531L35.5613 41.0036L35.5574 39.6728L35.863 39.8474L35.2478 38.5377L34.6378 39.1476L34.9448 39.3222Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8183 61.3164L46.3813 52.8946V44.8472L31.8183 53.269V61.3164Z",
    fill: "#C9974B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8179 53.2697L46.3809 44.848L32.2407 36.6154L17.6764 45.0371L31.8179 53.2697Z",
    fill: "#EBC26C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6764 45.0372L31.8179 53.2698V61.3172L17.6764 53.1282V45.0372Z",
    fill: "#AB7835"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8275 49.1938L39.4221 40.7085L38.2838 40.0695L23.6892 48.5548V51.0975L24.8511 51.792L24.8275 49.1938Z",
    fill: "#F2E5DA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2911 48.3838L19.2963 49.7147L19.9076 50.0639L19.9037 48.7331L20.2093 48.9077L19.5941 47.598L18.9841 48.2092L19.2911 48.3838Z",
    fill: "#471D1D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M32.362 34.5239L46.9251 26.1022V18.0547L32.362 26.4752V34.5239Z",
    fill: "#C9974B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3629 26.4753L46.926 18.0549L32.7859 9.82227L18.2228 18.2441L32.3629 26.4753Z",
    fill: "#EBC26C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2228 18.2448L32.3629 26.4761V34.5248L18.2228 26.3345V18.2448Z",
    fill: "#AB7835"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8351 21.5893L19.8403 22.9202L20.4529 23.2707L20.4477 21.9399L20.7533 22.1145L20.1381 20.8048L19.5294 21.4147L19.8351 21.5893Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 43.5814L31.2716 35.1597V27.1122L16.7086 35.534V43.5814Z",
    fill: "#C9974B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7095 35.5341L31.2726 27.1124L17.1324 18.8798L2.56938 27.3015L16.7095 35.5341Z",
    fill: "#EBC26C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56938 27.3016L16.7095 35.5342V43.5816L2.56938 35.3926V27.3016Z",
    fill: "#AB7835"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79976 31.5178L24.3944 23.0338L23.2561 22.3948L8.66147 30.8788V33.4228L9.82215 34.1173L9.79976 31.5178Z",
    fill: "#F2E5DA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18128 30.6489L4.18655 31.9797L4.79919 32.329L4.79393 30.9981L5.09957 31.1727L4.48431 29.863L3.87564 30.4742L4.18128 30.6489Z",
    fill: "#471D1D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4718 43.234L62.0348 34.8135V26.7648L47.4718 35.1866V43.234Z",
    fill: "#C9974B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4713 35.1867L62.0343 26.7649L47.8942 18.5323L33.3298 26.9541L47.4713 35.1867Z",
    fill: "#EBC26C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3298 26.9541L47.4713 35.1867V43.2341L33.3298 35.0452V26.9541Z",
    fill: "#AB7835"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9448 30.3014L34.9501 31.6323L35.5613 31.9815L35.5574 30.6507L35.863 30.8253L35.2478 29.5156L34.6378 30.1268L34.9448 30.3014Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8183 52.2953L46.3813 43.8735V35.8261L31.8183 44.2479V52.2953Z",
    fill: "#C9974B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8179 44.2487L46.3809 35.8269L32.2407 27.5943L17.6764 36.0161L31.8179 44.2487Z",
    fill: "#EBC26C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6764 36.0161L31.8179 44.2487V52.2961L17.6764 44.1058V36.0161Z",
    fill: "#AB7835"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8275 40.2377L39.4221 31.7524L38.2838 31.1134L23.6892 39.5987V42.1414L24.8511 42.8359L24.8275 40.2377Z",
    fill: "#F2E5DA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2911 39.3626L19.2963 40.6922L19.9076 41.0427L19.9037 39.7119L20.2093 39.8865L19.5941 38.5768L18.9841 39.1867L19.2911 39.3626Z",
    fill: "#471D1D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32.362 25.5015L46.9251 17.0811V9.03235L32.362 17.4541V25.5015Z",
    fill: "#C9974B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3629 17.4543L46.926 9.0325L32.7859 0.801208L18.2228 9.22168L32.3629 17.4543Z",
    fill: "#EBC26C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2228 9.22235L32.3629 17.455V25.5024L18.2228 17.3134V9.22235Z",
    fill: "#AB7835"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3712 13.325L39.9658 4.83968L38.8275 4.20068L24.2329 12.686V15.2287L25.3949 15.9232L25.3712 13.325Z",
    fill: "#F2E5DA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8351 12.5687L19.8403 13.8996L20.4529 14.2488L20.4477 12.918L20.7533 13.0939L20.1381 11.7829L19.5294 12.3941L19.8351 12.5687Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 34.5604L31.2716 26.1386V18.0912L16.7086 26.513V34.5604Z",
    fill: "#C9974B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7095 26.5131L31.2726 18.0913L17.1324 9.8587L2.56938 18.2805L16.7095 26.5131Z",
    fill: "#EBC26C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56938 18.2805L16.7095 26.5131V34.5605L2.56938 26.3702V18.2805Z",
    fill: "#AB7835"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18128 21.6276L4.18655 22.9585L4.79919 23.3077L4.79393 21.9769L5.09957 22.1515L4.48431 20.8418L3.87564 21.4517L4.18128 21.6276Z",
    fill: "#471D1D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4718 34.2129L62.0348 25.7911V17.7437L47.4718 26.1655V34.2129Z",
    fill: "#C9974B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4713 26.1656L62.0343 17.7438L47.8942 9.51123L33.3298 17.933L47.4713 26.1656Z",
    fill: "#EBC26C"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3298 17.933L47.4713 26.1656V34.2131L33.3298 26.0241V17.933Z",
    fill: "#AB7835"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3975 22.0398L54.9922 13.5545L53.8552 12.9155L39.2606 21.4008V23.9448L40.4212 24.638L40.3975 22.0398Z",
    fill: "#F2E5DA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9448 21.2803L34.9501 22.6111L35.5613 22.9604L35.5574 21.6295L35.863 21.8041L35.2478 20.4944L34.6378 21.1056L34.9448 21.2803Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8183 43.2749L46.3813 34.8531V26.8057L31.8183 35.2262V43.2749Z",
    fill: "#C9974B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8179 35.2263L46.3809 26.8058L32.2407 18.5732L17.6764 26.995L31.8179 35.2263Z",
    fill: "#EBC26C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6764 26.9951L31.8179 35.2264V43.2751L17.6764 35.0848V26.9951Z",
    fill: "#AB7835"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2911 30.3401L19.2963 31.671L19.9076 32.0202L19.9037 30.6893L20.2093 30.8653L19.5941 29.5556L18.9841 30.1655L19.2911 30.3401Z",
    fill: "#471D1D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0924 41.4584V35.5686L33.1754 35.521L45.1088 28.6219V34.5116L45.0258 34.5592L33.0924 41.4584ZM33.4217 35.7592V40.8869L44.7781 34.3198V29.1921L33.4217 35.7592Z",
    fill: "#965A2C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2081 39.0995V37.131L34.7154 36.8412C34.9709 36.6944 35.1685 36.6679 35.3042 36.7605C35.4413 36.8531 35.5084 37.0542 35.5084 37.3612C35.5084 37.6681 35.4413 37.9486 35.3095 38.2026C35.1764 38.4566 34.9722 38.6629 34.6995 38.819L34.2081 39.0995ZM34.5283 38.5306L34.7312 38.4155C34.8774 38.3309 34.9907 38.2158 35.0697 38.0689C35.1488 37.9221 35.1883 37.7514 35.1883 37.5556C35.1883 37.3625 35.1488 37.2342 35.0697 37.1746C34.9907 37.1164 34.8708 37.1336 34.7074 37.2262L34.5283 37.3281V38.5306Z",
    fill: "#965A2C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7858 38.1979V36.2295L36.82 35.6368V36.0297L36.106 36.4398V36.8446L36.7489 36.4768V36.8486L36.106 37.2164V37.6304L36.845 37.2084V37.5947L35.7858 38.1979Z",
    fill: "#965A2C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1284 37.4289V35.4604L37.4485 35.2766V36.8521L38.0611 36.5029V36.8945L37.1284 37.4289Z",
    fill: "#965A2C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M38.296 36.7624V34.7938L38.6174 34.6086V36.5772L38.296 36.7624Z",
    fill: "#965A2C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7854 34.5117L39.1319 34.3133L39.4981 35.3584L39.8617 33.8952L40.2095 33.6968L39.6325 35.996L39.3611 36.1508L38.7854 34.5117Z",
    fill: "#965A2C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3822 35.5668V33.5983L41.4177 33.0056V33.3985L40.7037 33.8073V34.2134L41.3453 33.8457V34.2174L40.7037 34.5852V34.9993L41.4401 34.5772V34.9636L40.3822 35.5668Z",
    fill: "#965A2C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7248 34.7979V32.8294L42.2689 32.5184C42.4929 32.3901 42.6509 32.3518 42.7458 32.4007C42.8407 32.4497 42.8881 32.5899 42.8881 32.8188C42.8881 33.1336 42.7972 33.3903 42.6154 33.5847L42.9777 34.0795L42.5838 34.3057L42.2649 33.8612L42.0436 33.9882V34.6153L41.7248 34.7979ZM42.0449 33.6073L42.2794 33.4723C42.3888 33.4101 42.4639 33.3426 42.5034 33.2712C42.5429 33.2011 42.5627 33.1111 42.5627 33.0053C42.5627 32.9021 42.5429 32.8399 42.5021 32.8254C42.4599 32.8082 42.3888 32.8307 42.286 32.8889L42.0449 33.0264V33.6073Z",
    fill: "#965A2C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9799 32.111L43.329 31.9125L43.6386 32.4682L43.9482 31.558L44.296 31.3596L43.7993 32.8359V33.6125L43.4779 33.7977V33.0198L42.9799 32.111Z",
    fill: "#965A2C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0924 50.4429V44.5532L33.1754 44.5056L45.1088 37.6064V43.4962L45.0258 43.5438L33.0924 50.4429ZM33.4217 44.7437V49.8714L44.7781 43.3043V38.1766L33.4217 44.7437Z",
    fill: "#965A2C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2083 48.0835V46.1149L34.7156 45.8252C34.9712 45.6797 35.1688 45.6532 35.3045 45.7459C35.4415 45.8371 35.5087 46.0396 35.5087 46.3465C35.5087 46.6534 35.4415 46.9325 35.3097 47.1892C35.1767 47.4419 34.9724 47.6482 34.6997 47.8043L34.2083 48.0835ZM34.5285 47.5146L34.7314 47.3982C34.8776 47.3135 34.9909 47.1998 35.0699 47.0516C35.149 46.9047 35.1885 46.7354 35.1885 46.5396C35.1885 46.3465 35.149 46.2194 35.0699 46.1599C34.9909 46.1004 34.871 46.1163 34.7077 46.2102L34.5285 46.3121V47.5146Z",
    fill: "#965A2C"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M35.786 47.1819V45.2133L36.8202 44.622V45.0149L36.1062 45.4237V45.8285L36.7491 45.4608V45.8325L36.1062 46.2003V46.6144L36.8452 46.1923V46.5786L35.786 47.1819Z",
    fill: "#965A2C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1286 46.4128V44.4442L37.4487 44.259V45.8373L38.0613 45.4867V45.8783L37.1286 46.4128Z",
    fill: "#965A2C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2962 45.7449V43.7764L38.6177 43.5925V45.561L38.2962 45.7449Z",
    fill: "#965A2C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7856 43.4956L39.1321 43.2984L39.4983 44.3422L39.8619 42.8804L40.2098 42.6819L39.6327 44.9799L39.3613 45.136L38.7856 43.4956Z",
    fill: "#965A2C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3824 44.5507V42.5822L41.4179 41.9895V42.3824L40.7039 42.7925V43.196L41.3455 42.8295V43.2013L40.7039 43.5678V43.9818L41.4403 43.5611V43.9474L40.3824 44.5507Z",
    fill: "#965A2C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M41.725 43.7834V41.8148L42.2691 41.504C42.4931 41.3756 42.6512 41.3386 42.746 41.3875C42.8409 41.4365 42.8883 41.5754 42.8883 41.8043C42.8883 42.1191 42.7974 42.3745 42.6156 42.5703L42.9779 43.0664L42.584 43.2913L42.2652 42.8467L42.0438 42.9737V43.6008L41.725 43.7834ZM42.0452 42.5914L42.2796 42.4578C42.389 42.3943 42.4641 42.3268 42.5036 42.2554C42.5431 42.1839 42.5629 42.0967 42.5629 41.9908C42.5629 41.885 42.5431 41.8254 42.5023 41.8095C42.4601 41.7924 42.389 41.8149 42.2862 41.8744L42.0452 42.012V42.5914Z",
    fill: "#965A2C"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9801 41.0948L43.3292 40.895L43.6388 41.4506L43.9484 40.5405L44.2962 40.342L43.7995 41.8184V42.595L43.4781 42.7789V42.0036L42.9801 41.0948Z",
    fill: "#965A2C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0924 59.4241V53.5344L33.1754 53.4868L45.1088 46.5877V52.4774L45.0258 52.525L33.0924 59.4241ZM33.4217 53.7249V58.8526L44.7781 52.2856V47.1579L33.4217 53.7249Z",
    fill: "#965A2C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2081 57.0645V55.096L34.7154 54.8063C34.9709 54.6594 35.1685 54.633 35.3042 54.7256C35.4413 54.8182 35.5084 55.0193 35.5084 55.3262C35.5084 55.6331 35.4413 55.9136 35.3095 56.1676C35.1764 56.4216 34.9722 56.6279 34.6995 56.7841L34.2081 57.0645ZM34.5283 56.4956L34.7312 56.3806C34.8774 56.2959 34.9907 56.1808 35.0697 56.0339C35.1488 55.8871 35.1883 55.7164 35.1883 55.5206C35.1883 55.3262 35.1488 55.1992 35.0697 55.1396C34.9907 55.0814 34.8708 55.0986 34.7074 55.1912L34.5283 55.2931V56.4956Z",
    fill: "#965A2C"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7858 56.163V54.1945L36.82 53.6018V53.9947L36.106 54.4048V54.8096L36.7489 54.4419V54.8136L36.106 55.1814V55.5955L36.845 55.1734V55.5598L35.7858 56.163Z",
    fill: "#965A2C"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1284 55.394V53.4255L37.4485 53.2416V54.8172L38.0611 54.4679V54.8595L37.1284 55.394Z",
    fill: "#965A2C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M38.296 54.7275V52.759L38.6174 52.5737V54.5423L38.296 54.7275Z",
    fill: "#965A2C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7854 52.4767L39.1319 52.2783L39.4981 53.3234L39.8617 51.8589L40.2095 51.6605L39.6325 53.9597L39.3611 54.1145L38.7854 52.4767Z",
    fill: "#965A2C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3822 53.5332V51.5647L41.4177 50.972V51.365L40.7037 51.7738V52.1799L41.3453 51.8121V52.1839L40.7037 52.5516V52.9657L41.4401 52.5437V52.93L40.3822 53.5332Z",
    fill: "#965A2C"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7248 52.7642V50.7957L42.2689 50.4848C42.4929 50.3565 42.6509 50.3181 42.7458 50.3671C42.8407 50.416 42.8881 50.5563 42.8881 50.7851C42.8881 51.1 42.7972 51.3567 42.6154 51.5511L42.9777 52.0459L42.5838 52.2721L42.2649 51.8276L42.0436 51.9546V52.5817L41.7248 52.7642ZM42.0449 51.5723L42.2794 51.4374C42.3888 51.3752 42.4639 51.3077 42.5034 51.2363C42.5429 51.1661 42.5627 51.0762 42.5627 50.9704C42.5627 50.8672 42.5429 50.805 42.5021 50.7904C42.4599 50.7732 42.3888 50.7957 42.286 50.8539L42.0449 50.9915V51.5723Z",
    fill: "#965A2C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9799 50.076L43.329 49.8776L43.6386 50.4332L43.9482 49.5217L44.296 49.3232L43.7993 50.7996V51.5762L43.4779 51.7614V50.9835L42.9799 50.076Z",
    fill: "#965A2C"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0924 68.4078V62.5167L33.1754 62.4691L45.1088 55.57V61.461L45.0258 61.5086L33.0924 68.4078ZM33.4217 62.7072V67.8362L44.7781 61.2692V56.1402L33.4217 62.7072Z",
    fill: "#965A2C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2083 66.0505V64.0819L34.7156 63.7922C34.9712 63.6467 35.1688 63.6202 35.3045 63.7115C35.4415 63.8028 35.5087 64.0052 35.5087 64.3121C35.5087 64.6204 35.4415 64.8982 35.3097 65.1548C35.1767 65.4075 34.9724 65.6139 34.6997 65.77L34.2083 66.0505ZM34.5285 65.4803L34.7314 65.3639C34.8776 65.2792 34.9909 65.1654 35.0699 65.0172C35.149 64.8704 35.1885 64.7011 35.1885 64.5053C35.1885 64.3108 35.149 64.1851 35.0699 64.1256C34.9909 64.0661 34.871 64.0819 34.7077 64.1759L34.5285 64.2777V65.4803Z",
    fill: "#965A2C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M35.786 65.1472V63.1787L36.8202 62.5873V62.9802L36.1062 63.389V63.7938L36.7491 63.426V63.7978L36.1062 64.1656V64.5797L36.8452 64.1576V64.5439L35.786 65.1472Z",
    fill: "#965A2C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1286 64.3781V62.4096L37.4487 62.2244V63.8026L38.0613 63.4521V63.8436L37.1286 64.3781Z",
    fill: "#965A2C"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2962 63.7103V61.7418L38.6177 61.5579V63.5264L38.2962 63.7103Z",
    fill: "#965A2C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7856 61.4609L39.1321 61.2638L39.4983 62.3076L39.8619 60.8457L40.2098 60.6473L39.6327 62.9452L39.3613 63.1013L38.7856 61.4609Z",
    fill: "#965A2C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3824 62.5174V60.5488L41.4179 59.9562V60.3491L40.7039 60.7592V61.1627L41.3455 60.7963V61.168L40.7039 61.5344V61.9485L41.4403 61.5278V61.9141L40.3824 62.5174Z",
    fill: "#965A2C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M41.725 61.7487V59.7802L42.2691 59.4693C42.4931 59.3409 42.6512 59.3039 42.746 59.3529C42.8409 59.4018 42.8883 59.5407 42.8883 59.7696C42.8883 60.0845 42.7974 60.3398 42.6156 60.5356L42.9779 61.0317L42.584 61.2566L42.2652 60.8121L42.0438 60.9391V61.5661L41.725 61.7487ZM42.0452 60.5567L42.2796 60.4231C42.389 60.3596 42.4641 60.2922 42.5036 60.2207C42.5431 60.1493 42.5629 60.062 42.5629 59.9561C42.5629 59.8503 42.5431 59.7908 42.5023 59.7749C42.4601 59.7577 42.389 59.7802 42.2862 59.8397L42.0452 59.976V60.5567Z",
    fill: "#965A2C"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9801 59.0601L43.3292 58.8604L43.6388 59.416L43.9484 58.5058L44.2962 58.3074L43.7995 59.7838V60.5603L43.4781 60.7442V59.969L42.9801 59.0601Z",
    fill: "#965A2C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7462 32.4228V26.5317L48.8292 26.4842L60.7626 19.585V25.476L60.6796 25.5237L48.7462 32.4228ZM49.0756 26.7223V31.8513L60.4319 25.2842V20.1552L49.0756 26.7223Z",
    fill: "#965A2C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8606 30.0633V28.0948L50.3679 27.8051C50.6234 27.6582 50.821 27.6317 50.9567 27.7244C51.0938 27.8156 51.1623 28.0167 51.1623 28.3236C51.1623 28.6306 51.0951 28.911 50.962 29.1663C50.8276 29.419 50.6248 29.6267 50.3521 29.7815L49.8606 30.0633ZM50.1834 29.4931L50.385 29.378C50.5325 29.2947 50.6445 29.1783 50.7236 29.0314C50.8026 28.8846 50.8421 28.7152 50.8421 28.5181C50.8421 28.325 50.8026 28.1979 50.7236 28.1384C50.6445 28.0789 50.526 28.0961 50.3626 28.19L50.1834 28.2906V29.4931Z",
    fill: "#965A2C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4411 29.1605V27.1919L52.4766 26.6006V26.9935L51.7612 27.4023V27.8084L52.4041 27.4393V27.8111L51.7612 28.1802V28.5943L52.5003 28.1709V28.5585L51.4411 29.1605Z",
    fill: "#965A2C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7836 28.3927V26.4241L53.1051 26.239V27.8159L53.7164 27.4666V27.8569L52.7836 28.3927Z",
    fill: "#965A2C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 27.7248V25.7563L54.2713 25.5711V27.5396L53.9512 27.7248Z",
    fill: "#965A2C"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4406 25.4754L54.7871 25.277L55.1533 26.3208L55.5169 24.859L55.8661 24.6605L55.289 26.9598L55.0176 27.1146L54.4406 25.4754Z",
    fill: "#965A2C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 26.5293V24.5608L57.0717 23.9694V24.3623L56.3576 24.7711V25.1759L57.0005 24.8082V25.1799L56.3576 25.5477V25.9617L57.0954 25.5397V25.9273L56.0375 26.5293Z",
    fill: "#965A2C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38 25.7616V23.7931L57.9241 23.4809C58.1481 23.3539 58.3062 23.3155 58.401 23.3645C58.4959 23.4134 58.5433 23.5536 58.5433 23.7825C58.5433 24.0974 58.4524 24.3527 58.2706 24.5472L58.633 25.0433L58.239 25.2682L57.9202 24.8237L57.6989 24.9507V25.5791L57.38 25.7616ZM57.7002 24.571L57.9347 24.4361C58.0441 24.3739 58.1191 24.3064 58.16 24.235C58.1982 24.1635 58.2192 24.0749 58.2192 23.9691C58.2192 23.8646 58.1982 23.8037 58.1573 23.7878C58.1165 23.7719 58.044 23.7931 57.9413 23.8526L57.7002 23.9902V24.571Z",
    fill: "#965A2C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6351 23.0747L58.9842 22.8749L59.2925 23.4305L59.6021 22.519L59.9499 22.3206L59.4532 23.7983V24.5736L59.1318 24.7588V23.9822L58.6351 23.0747Z",
    fill: "#965A2C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7462 41.4072V35.5175L48.8292 35.4698L60.7626 28.5707V34.4604L60.6796 34.5081L48.7462 41.4072ZM49.0756 35.7079V40.8356L60.4319 34.2686V29.1409L49.0756 35.7079Z",
    fill: "#965A2C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8606 39.0495V37.081L50.3679 36.7913C50.6234 36.6444 50.821 36.618 50.9567 36.7106C51.0938 36.8018 51.1623 37.0029 51.1623 37.3098C51.1623 37.6168 51.0951 37.8973 50.962 38.1526C50.8276 38.4053 50.6248 38.613 50.3521 38.7677L49.8606 39.0495ZM50.1834 38.4793L50.385 38.3642C50.5325 38.2796 50.6445 38.1645 50.7236 38.0176C50.8026 37.8708 50.8421 37.7014 50.8421 37.5043C50.8421 37.3112 50.8026 37.1842 50.7236 37.1247C50.6445 37.0651 50.526 37.0823 50.3626 37.1763L50.1834 37.2768V38.4793Z",
    fill: "#965A2C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4411 38.1467V36.1781L52.4766 35.5868V35.9797L51.7612 36.3885V36.7946L52.4041 36.4255V36.7972L51.7612 37.1664V37.5804L52.5003 37.1571V37.5447L51.4411 38.1467Z",
    fill: "#965A2C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7836 37.3789V35.4104L53.1051 35.2252V36.8021L53.7164 36.4529V36.8431L52.7836 37.3789Z",
    fill: "#965A2C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 36.711V34.7425L54.2713 34.5573V36.5258L53.9512 36.711Z",
    fill: "#965A2C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4406 34.4617L54.7871 34.2632L55.1533 35.307L55.5169 33.8452L55.8661 33.6467L55.289 35.946L55.0176 36.1007L54.4406 34.4617Z",
    fill: "#965A2C"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 35.5162V33.5476L57.0717 32.9563V33.3492L56.3576 33.758V34.1628L57.0005 33.795V34.1668L56.3576 34.5345V34.9486L57.0954 34.5266V34.9143L56.0375 35.5162Z",
    fill: "#965A2C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38 34.7479V32.7793L57.9241 32.4671C58.1481 32.3401 58.3062 32.3017 58.401 32.3507C58.4959 32.3996 58.5433 32.5399 58.5433 32.7687C58.5433 33.0836 58.4524 33.3389 58.2706 33.5334L58.633 34.0295L58.239 34.2544L57.9202 33.8099L57.6989 33.9369V34.5653L57.38 34.7479ZM57.7002 33.5572L57.9347 33.4223C58.0441 33.3601 58.1191 33.2926 58.16 33.2212C58.1982 33.1497 58.2192 33.0611 58.2192 32.9553C58.2192 32.8508 58.1982 32.7899 58.1573 32.774C58.1165 32.7582 58.044 32.7793 57.9413 32.8389L57.7002 32.9751V33.5572Z",
    fill: "#965A2C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6351 32.0609L58.9842 31.8611L59.2925 32.4168L59.6021 31.5053L59.9499 31.3068L59.4532 32.7845V33.5598L59.1318 33.745V32.9684L58.6351 32.0609Z",
    fill: "#965A2C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7462 50.3883V44.4986L48.8292 44.451L60.7626 37.5519V43.4416L60.6796 43.4892L48.7462 50.3883ZM49.0756 44.6891V49.8168L60.4319 43.2497V38.1221L49.0756 44.6891Z",
    fill: "#965A2C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8606 48.0288V46.0602L50.3679 45.7705C50.6234 45.6237 50.821 45.5972 50.9567 45.6898C51.0938 45.7811 51.1623 45.9822 51.1623 46.2891C51.1623 46.596 51.0951 46.8765 50.962 47.1318C50.8276 47.3845 50.6248 47.5922 50.3521 47.747L49.8606 48.0288ZM50.1834 47.4586L50.385 47.3435C50.5325 47.2601 50.6445 47.1437 50.7236 46.9969C50.8026 46.85 50.8421 46.6807 50.8421 46.4836C50.8421 46.2904 50.8026 46.1634 50.7236 46.1039C50.6445 46.0444 50.526 46.0616 50.3626 46.1555L50.1834 46.256V47.4586Z",
    fill: "#965A2C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4411 47.1259V45.1574L52.4766 44.566V44.9589L51.7612 45.3677V45.7739L52.4041 45.4048V45.7765L51.7612 46.1456V46.5597L52.5003 46.1363V46.524L51.4411 47.1259Z",
    fill: "#965A2C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7836 46.3582V44.3897L53.1051 44.2045V45.7814L53.7164 45.4322V45.8224L52.7836 46.3582Z",
    fill: "#965A2C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 45.6903V43.7218L54.2713 43.5366V45.5051L53.9512 45.6903Z",
    fill: "#965A2C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4406 43.441L54.7871 43.2425L55.1533 44.2863L55.5169 42.8245L55.8661 42.626L55.289 44.9253L55.0176 45.0801L54.4406 43.441Z",
    fill: "#965A2C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 44.4962V42.5276L57.0717 41.9363V42.3292L56.3576 42.738V43.1428L57.0005 42.775V43.1468L56.3576 43.5145V43.9286L57.0954 43.5066V43.8942L56.0375 44.4962Z",
    fill: "#965A2C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38 43.7272V41.7586L57.9241 41.4464C58.1481 41.3194 58.3062 41.281 58.401 41.33C58.4959 41.3789 58.5433 41.5192 58.5433 41.7481C58.5433 42.0629 58.4524 42.3182 58.2706 42.5127L58.633 43.0088L58.239 43.2337L57.9202 42.7892L57.6989 42.9162V43.5446L57.38 43.7272ZM57.7002 42.5365L57.9347 42.4016C58.0441 42.3394 58.1191 42.2719 58.16 42.2005C58.1982 42.129 58.2192 42.0404 58.2192 41.9346C58.2192 41.8301 58.1982 41.7692 58.1573 41.7533C58.1165 41.7375 58.044 41.7586 57.9413 41.8181L57.7002 41.9544V42.5365Z",
    fill: "#965A2C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6351 41.0402L58.9842 40.8405L59.2925 41.3961L59.6021 40.4859L59.9499 40.2875L59.4532 41.7639V42.5391L59.1318 42.7243V41.9478L58.6351 41.0402Z",
    fill: "#965A2C"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7462 59.3717V53.482L48.8292 53.4344L60.7626 46.5353V52.425L60.6796 52.4726L48.7462 59.3717ZM49.0756 53.6725V58.8002L60.4319 52.2332V47.1055L49.0756 53.6725Z",
    fill: "#965A2C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8606 57.0144V55.0458L50.3679 54.7561C50.6234 54.6093 50.821 54.5828 50.9567 54.6754C51.0938 54.7667 51.1623 54.9678 51.1623 55.2747C51.1623 55.5816 51.0951 55.8621 50.962 56.1174C50.8276 56.3701 50.6248 56.5778 50.3521 56.7326L49.8606 57.0144ZM50.1834 56.4442L50.385 56.3291C50.5325 56.2444 50.6445 56.1293 50.7236 55.9825C50.8026 55.8356 50.8421 55.6663 50.8421 55.4692C50.8421 55.276 50.8026 55.149 50.7236 55.0895C50.6445 55.0299 50.526 55.0471 50.3626 55.1411L50.1834 55.2416V56.4442Z",
    fill: "#965A2C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4411 56.1115V54.143L52.4766 53.5516V53.9445L51.7612 54.3534V54.7595L52.4041 54.3904V54.7621L51.7612 55.1312V55.5453L52.5003 55.122V55.5096L51.4411 56.1115Z",
    fill: "#965A2C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7836 55.3438V53.3753L53.1051 53.1901V54.767L53.7164 54.4178V54.808L52.7836 55.3438Z",
    fill: "#965A2C"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 54.6759V52.7073L54.2713 52.5222V54.4906L53.9512 54.6759Z",
    fill: "#965A2C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4406 52.4266L54.7871 52.2281L55.1533 53.2719L55.5169 51.8101L55.8661 51.6116L55.289 53.9109L55.0176 54.0657L54.4406 52.4266Z",
    fill: "#965A2C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 53.4804V51.5119L57.0717 50.9205V51.3134L56.3576 51.7222V52.127L57.0005 51.7592V52.131L56.3576 52.4988V52.9128L57.0954 52.4908V52.8784L56.0375 53.4804Z",
    fill: "#965A2C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38 52.7141V50.7456L57.9241 50.4334C58.1481 50.3064 58.3062 50.268 58.401 50.3169C58.4959 50.3659 58.5433 50.5048 58.5433 50.735C58.5433 51.0499 58.4524 51.3052 58.2706 51.4997L58.633 51.9958L58.239 52.2207L57.9202 51.7761L57.6989 51.9031V52.5315L57.38 52.7141ZM57.7002 51.5221L57.9347 51.3872C58.0441 51.325 58.1191 51.2576 58.16 51.1861C58.1982 51.1147 58.2192 51.0261 58.2192 50.9202C58.2192 50.8157 58.1982 50.7548 58.1573 50.739C58.1165 50.7231 58.044 50.7443 57.9413 50.8038L57.7002 50.9414V51.5221Z",
    fill: "#965A2C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6351 50.0258L58.9842 49.8261L59.2925 50.3817L59.6021 49.4715L59.9499 49.2731L59.4532 50.7508V51.526L59.1318 51.7113V50.9347L58.6351 50.0258Z",
    fill: "#965A2C"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8288 31.1957L39.4235 22.7104L38.2852 22.0715L23.6906 30.5568V33.1007L24.8525 33.794L24.8288 31.1957Z",
    fill: "#F2E5DA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79826 22.4786L24.3929 13.9933L23.2546 13.3543L8.65997 21.8396V24.3823L9.82066 25.0768L9.79826 22.4786Z",
    fill: "#F2E5DA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56715 49.1407V43.5447L31.8171 57.9647L62.0353 41.3513V49.1023L31.9989 64.6772L2.56715 49.1407Z",
    fill: "#DAB697"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56715 43.4177V37.823L31.8171 55.0106L62.0353 35.6296V43.3794L31.9989 60.1846L2.56715 43.4177Z",
    fill: "#DAB697"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56715 32.7797V27.185L31.8171 41.605L62.0353 24.9916V32.7427L31.9989 48.3176L2.56715 32.7797Z",
    fill: "#DAB697"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56715 27.058V21.462L31.8171 38.6495L62.0353 19.2686V27.0196L31.9989 43.8248L2.56715 27.058Z",
    fill: "#DAB697"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxGrouped);
export default __webpack_public_path__ + "static/media/boxGrouped.84b61bffd8d2629270584c72ab9caacc.svg";
export { ForwardRef as ReactComponent };